import React from 'react';
import AboutSection from '../../sections/AboutSection/AboutSection';
import HeroSection from '../../sections/HeroSection/HeroSection';
import ServicesSection from '../../sections/ServicesSection/ServicesSection';
import ContactSection from '../../sections/ContactSection/ContactSection';
import ProcessSection from '../../sections/ProcessSection/ProcessSection';
import PortfolioSection from '../../sections/PortfolioSection/PortfolioSection';
import TestimonialsSection from '../../sections/TestimonialsSection/TestimonialsSection';
import StudioSection from '../../sections/StudioSection/StudioSection';
import PainPointsSection from '../../sections/PainPointsSection/PainPointsSection';
import PromiseSection from '../../sections/PromiseSection/PromiseSection';
import BenefitsSection from '../../sections/BenefitsSection/BenefitsSection';
import FormSection from '../../sections/FormSection/FormSection';

// Mapeo de tipos de sección a componentes
const SECTION_COMPONENTS = {
  'about': AboutSection,
  'hero': HeroSection,
  'services': ServicesSection,
  'contact': ContactSection,
  'process': ProcessSection,
  'portfolio': PortfolioSection,
  'testimonials': TestimonialsSection,
  'studio': StudioSection,
  'painpoints': PainPointsSection,
  'promise': PromiseSection,
  'benefits': BenefitsSection,
  'form': FormSection,
};

/**
 * Componente Section genérico que renderiza diferentes tipos de secciones
 * según el tipo especificado en las props
 * @param {string} type - Tipo de sección a renderizar
 * @param {object} data - Datos para la sección
 */
const Section = ({ type, data, sectionId, ...rest }) => {
  const SectionComponent = SECTION_COMPONENTS[type];

  if (!SectionComponent) {
    console.warn(`Section type "${type}" not found`);
    return null;
  }

  if (sectionId) {
    return (
      <div id={sectionId}>
        <SectionComponent {...data} {...rest} />
      </div>
    );
  }

  return <SectionComponent {...data} {...rest} />;
};

export default Section;
